import React from 'react';
import { Navigate } from 'react-router-dom';

const Classes = _ => {
  return (
    <Navigate replace to='/littleangel' />
  )
}

export default Classes;